/**
 * Presentation Registry — maps layout → React component.
 *
 * This is the SINGLE source of truth for which component renders each layout.
 * Do not put layout conditionals in WorkspacePage or message renderers.
 *
 * To add a new layout:
 *   1. Create the component in this directory
 *   2. Import it here
 *   3. Add to PRESENTATION_RENDERERS
 *   No other file needs to change.
 */

import { RecipeShowcaseRenderer } from './RecipeShowcase';
import StudyShowcase from './StudyShowcase';
import BibleStudyShowcase from './BibleStudyShowcase';
import PlanShowcase from './PlanShowcase';
import ChecklistShowcase from './ChecklistShowcase';
import ReportShowcase from './ReportShowcase';
import ComparisonShowcase from './ComparisonShowcase';
import TutorialShowcase from './TutorialShowcase';
import AnalysisShowcase from './AnalysisShowcase';
import ScheduleShowcase from './ScheduleShowcase';
import FinanceShowcase from './FinanceShowcase';
import TravelShowcase from './TravelShowcase';
import BookSummaryShowcase from './BookSummaryShowcase';

/**
 * layout → Component
 *
 * Each component receives:
 *   wp         — the full workspace_presentation object
 *   onAction   — optional callback(actionId: string) for copy/save/share
 */
export const PRESENTATION_RENDERERS = {
  recipe:       RecipeShowcaseRenderer,
  study:        StudyShowcase,
  bible_study:  BibleStudyShowcase,
  plan:         PlanShowcase,
  checklist:    ChecklistShowcase,
  report:       ReportShowcase,
  comparison:   ComparisonShowcase,
  tutorial:     TutorialShowcase,
  analysis:     AnalysisShowcase,
  schedule:     ScheduleShowcase,
  finance:      FinanceShowcase,
  travel:       TravelShowcase,
  book_summary: BookSummaryShowcase,
};

/**
 * Get the component for a layout, or null if unknown.
 */
export function getRenderer(layout) {
  return PRESENTATION_RENDERERS[layout] || null;
}

/**
 * Return true if the workspace_presentation has a registered premium renderer.
 */
export function hasPremiumRenderer(wp) {
  if (!wp || !wp.layout) return false;
  return wp.layout in PRESENTATION_RENDERERS;
}
